import { CommCard } from '../comm-card/comm-card.model';
import { ConnectedDevice } from '../connected-device.model';
import { ToroController } from '../toro-controller.model';

export class EvoAddReplaceProcessUpdateNotification {
    constructor(json: any, Id: string = null) {
        if (json) {
            Object.assign(this, json);

            if (json.CommCard) this.CommCard = new CommCard(json.CommCard);
            if (json.Controller) this.Controller = new ToroController(json.Controller);
            if (json.Gateway) this.Gateway = new ConnectedDevice(json.Gateway);
        }

        if (Id && Id !== null)
            this.NotificationId = Id;
    }

    CommCard: CommCard;
    Controller: ToroController;
    Gateway: ConnectedDevice;
    IsLastStep: boolean;
    NotificationType: string;
    NotificationId: string;
    ReportedException: any;
    TypeCode: number;
    Operation: string;
}
